import * as Sentry from '@sentry/nextjs';
import { configuration } from './environment';

let sentryInitialized = false;

// Capturing errors need to be async, because otherwise serverless environments might not report errors.
export async function captureError(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any
) {
  if (!sentryInitialized) {
    return;
  }
  Sentry.captureException(error);
  await Sentry.flush(2000);
}

export function setupSentry() {
  if (configuration.sentry.DSN) {
    Sentry.init({
      dsn: configuration.sentry.DSN,
      environment: process.env.DEPLOYMENT_ENV,
      release: process.env.COMMIT_SHA,
      tracePropagationTargets: ['localhost', /^\//]
    });
    sentryInitialized = true;
  }
}
